import { combineReducers } from 'redux'
import cropper from './cropper'

export default combineReducers({
  cropper
})
